import { createContext, useContext } from "react";

interface IHoverHandlerContext {
  handleParentMouseEnter: () => void;
  handleParentMouseLeave: () => void;
}

export const hoverHandlerContext = createContext<IHoverHandlerContext>({
  handleParentMouseEnter: () => undefined,
  handleParentMouseLeave: () => undefined,
});

export const useHoverHandlerContext = () => useContext(hoverHandlerContext);
